import { DealerItem } from "../../../shared/filtro-dealers/filtro-dealers.component";
import { VeiculosPropostasFiltroService } from "./veiculos-propostas-filtro.service";

export class FiltroDealers {

  dealers: DealerItem[] = [];

  constructor(private servico: VeiculosPropostasFiltroService) { }

  carregar(): Promise<void> {
    return this.servico.getFiltroDealers()
      .then((r: any) => {
        this.preencher(r.filtros);
      });
  }

  public idsUsuario(): string {
    return this.dealers.map(d => d.id).join(',');
  }

  public selecionados(): any {
    let selecionados = [];
    selecionados = this.dealers.filter(m => m.selecionado).map(m => m);

    return selecionados;
  }

  public naoSelecionados(): any {
    let selecionados = [];
    selecionados = this.dealers.filter(m => !m.selecionado).map(m => m);

    return selecionados;
  }

  private preencher(dados: any) {
    this.inserirItens(dados);
  }

  private inserirItens(dados: any) {
    dados.forEach(dealer => {
      const i: number = this.dealers.map(m => m.id).indexOf(dealer.id);
      if (i < 0) {
        const item: DealerItem = {
          'id': dealer.id,
          'nome': dealer.descricao,
          'toTexto': function () { return this.nome },
          'toDescricao': function () { return null },
          'selecionado': false
        };
        this.dealers.push(item);
      }
    });
  }

}